import { render, staticRenderFns } from "./TemplateSolicitacao.vue?vue&type=template&id=6164b2c9"
import script from "./TemplateSolicitacao.vue?vue&type=script&lang=js"
export * from "./TemplateSolicitacao.vue?vue&type=script&lang=js"
import style0 from "./TemplateSolicitacao.vue?vue&type=style&index=0&id=6164b2c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports